// DraggableItem.js
import React, { useEffect, useState } from 'react'

const DraggableItem = ({
  text,
  id,
  left,
  top,
  right,
  height,
  width,
  bgColor,
  font,
  isBold,
  isItalic,
  isUnderline,
  isSelected,
  handleItemClick,
  handleDragStart,
  handleDragOver,
  handleDrop,
  items,
  setItems,
  isPrePrinted,
}) => {
  const itemId = id

  const [isEditing, setIsEditing] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  const handleDoubleClick = () => {
    setIsEditing(true)
  }
  const handleBlur = () => {
    setIsEditing(false)
  }

  const handleSave = (val) => {
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === itemId) {
        items[i].text = val
        break
      }
    }
    setItems(items)
  }

  return (
    <div
      draggable
      //className="draggableItem"
      className={`item ${isSelected || isEditing ? 'selectedItem' : isHovered ? 'unselectedItem' : ''}`}
      onDragStart={(e) => handleDragStart(e)}
      onDragOver={(e) => handleDragOver(e)}
      onDrop={(e) => e.preventDefault()}
      onClick={(e) => {
        handleItemClick(itemId)
      }}
      onDoubleClick={handleDoubleClick}
      id={itemId}
      //for hover effect
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        //  backgroundColor: isSelected ? '#F2F9FF' : bgColor,
        backgroundColor: bgColor,
        cursor: 'move',
        position: 'absolute',
        left: `${left}px`,
        top: `${top}px`,
        // right: `${right}px`,
        fontSize: `${font}pt`,
        fontWeight: isBold ? 'bold' : 'normal',
        fontStyle: isItalic ? 'italic' : 'normal',
        textDecoration: isUnderline ? 'underline' : 'none',
        //  border: isSelected ? '1px solid #0086ff' : 'none',
        //   border: isHovered ? '1px solid #0086ff' : 'none',
      }}
    >
      <div className={`${isSelected || isEditing ? ' selected2' : ''}`}>
        {
          // isPrePrinted &&
          isEditing ? (
            <input
              id={itemId}
              type="text"
              value={text}
              autoFocus
              onBlur={(e) => {
                handleBlur()
              }}
              onChange={(e) => {
                handleSave(e.target.value)
              }}
              style={{
                width: '100%',
                height: '100%',
                fontSize: `${font}px`,
                fontWeight: isBold ? 'bold' : 'normal',
                fontStyle: isItalic ? 'italic' : 'normal',
                textDecoration: isUnderline ? 'underline' : 'none',
                // border: 'none',
                // border: '1px solid #0086ff',
                outline: 'none',
              }}
            />
          ) : (
            <span>{text === 'ThermalPrintSplitter' ? '' : text}</span>
          )
        }
      </div>
      {/* {text} */}
    </div>
  )
}

export default DraggableItem
